import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { toast } from '../../../lib/toast';
import { createUser, type CreateUserRequest } from '../api/users';

export function useCreateUser(onSuccess?: (createdId: string) => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateUserRequest) => createUser(data),
    onSuccess: (result) => {
      invalidateListResource(queryClient, 'users');
      toast.success('User created');
      onSuccess?.(result.id);
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
      const detail = axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title;
      toast.error(detail ?? 'Failed to create user');
    },
  });
}

